import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const StyledFieldWrapper = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '.5rem',
  flexDirection: 'column',
}));
